/**
 * Error thrown by the HTTP client for non-2xx responses. Carries the status
 * code and any parsed body so callers can branch on failure modes.
 */
export class HttpError extends Error {
  readonly status: number
  readonly statusText: string
  readonly body: unknown

  constructor(status: number, statusText: string, body: unknown) {
    super(`HTTP ${status} ${statusText}`)
    this.name = 'HttpError'
    this.status = status
    this.statusText = statusText
    this.body = body
  }

  /** Distinguishes user-initiated cancellation from genuine failures. */
  static isAbort(error: unknown): boolean {
    return error instanceof DOMException && error.name === 'AbortError'
  }
}

/** Returns a human-readable API error detail when the response provides one. */
export function getHttpErrorMessage(error: unknown): string | undefined {
  if (!(error instanceof HttpError) || !isRecord(error.body)) return undefined

  if (typeof error.body.error === 'string') return error.body.error

  const { detail } = error.body
  if (typeof detail === 'string') return detail
  if (isRecord(detail) && typeof detail.error === 'string') return detail.error

  return undefined
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}
